module.exports = "/img/15.ab31f2.webp";